// external imports
import React from 'react'
import { createFragmentContainer, graphql } from 'react-relay'
// local imports
import { Map, Marker } from '~/components'

// the center of the atlantic ocean
const center = { lat: 33.23807508143733, lng: -41.1328125 }

const DistributorMap = ({ distributors }) => {
    const locations = distributors ? distributors.edges.map(({ node }) => node) : []
    return (
        <Map style={{ marginBottom: 24, height: 400 }} center={center} zoom={2}>
            {locations.map(location => (
                <Marker
                    position={{
                        lng: location.longitude,
                        lat: location.latitude
                    }}
                    key={`${location.longitude}:${location.latitude}`}
                />
            ))}
        </Map>
    )
}

export default DistributorMap



// WEBPACK FOOTER //
// ./src/views/Distributors/DistributorMap/index.js